import { Cloud$OAuthToken } from '@otovo/shared/types/cloudApi';
import { setUser } from '@sentry/nextjs';
import useSWRMutation from 'swr/mutation';
import { setToken } from '../../../utils/auth/auth';
import { GetTokenError } from './errors/GetTokenError';
import { UnauthorizedError } from './errors/UnauthorizedError';
import fetchProfile from './fetchProfile';

type LoginRequest = {
  username: string;
  password: string;
};

const sendRequest = async (url: string, { arg }: { arg: LoginRequest }) => {
  const sendPasswordRequest = await fetch(
    process.env.NEXT_PUBLIC_MYPAGE_LOGIN_PATH,
    {
      method: 'post',
      body: JSON.stringify(arg),
      headers: { 'content-type': 'application/json' },
    },
  );

  if (sendPasswordRequest.status === 401) {
    // Wrong username/pw
    throw new UnauthorizedError();
  }

  if (!sendPasswordRequest.ok) {
    const text = await sendPasswordRequest.text();

    // Something else is wrong
    throw new GetTokenError(text);
  }

  const data = await sendPasswordRequest.json();
  const token = data as Cloud$OAuthToken;
  token.received = new Date();
  setToken(token);

  const user = await fetchProfile();
  setUser({
    email: user.email,
  });
  return user;
};

export default function useLogin() {
  const { trigger, isMutating, error } = useSWRMutation('login', sendRequest, {
    throwOnError: false,
  });

  return {
    trigger,
    isLoggingIn: isMutating,
    error,
  };
}
